import { Component, OnInit, Input, Output, SimpleChanges, ViewChild, ElementRef, EventEmitter, OnChanges } from '@angular/core';

@Component({
  selector: 'say-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
})

export class ToastComponent implements OnInit, OnChanges {
  
  public hideToast: boolean = true;

  @ViewChild('toast', { static: false }) toast: ElementRef;
  @Input() toggle5s: boolean;
  @Input() toggle3s: boolean;
  @Input() toggle7s: boolean;
  @Output() toggleOff: EventEmitter<any> = new EventEmitter();

  constructor() {}
  
  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.toggle3s) {
      this.toastThreeSeconds();
    }
    else if (this.toggle5s) {
      this.toastFiveSeconds();
    } 
    else if (this.toggle7s) {
      this.toastSevenSeconds();
    }
  }
  
  /** Setup toast with 3 second timeout */
  toastThreeSeconds() {
    this.hideToast = false;
    setTimeout(() => {
      this.toast.nativeElement.classList.add('say-toast--3s');
    }, 5);
    this.setupToast(3000);
  }
  
  /** Setup toast with 5 second timeout */
  toastFiveSeconds() {
    this.hideToast = false;
    setTimeout(() => {
      this.toast.nativeElement.classList.add('say-toast--5s');
    }, 5);
    this.setupToast(5000);
  }

  /** Setup toast with 5 second timeout */
  toastSevenSeconds() {
    this.hideToast = false;
    setTimeout(() => {
      this.toast.nativeElement.classList.add('say-toast--7s');
    }, 5);
    this.setupToast(7000);
  }
  
  /** Shows toast message and closes (param) milliseconds after.
  * @param timeout time to remove toast message from view (3000 or 5000)
  */
  private setupToast(timeout: number) {
    setTimeout(this.removeToast.bind(this), timeout);
  }

  private removeToast() {
    this.hideToast = true;
    this.toggleOff.emit(null);
  }
}